// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadingOverlay[data-v-3c5658ee]{position:absolute;left:0;top:0;height:100vh;width:100vw}.img-container[data-v-3c5658ee]{position:relative;overflow:hidden}.background-image[data-v-3c5658ee]{position:absolute;min-width:1000%;min-height:1000%;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) scale(.1);transform:translateX(-50%) translateY(-50%) scale(.1);z-index:-1}", ""]);
// Exports
module.exports = exports;
